import React, {useEffect, useMemo, useState} from 'react'
import {useLocation, useNavigate, useOutletContext, useSearchParams} from "react-router-dom";

import CardList from "../../../components/CardList";
import ErrorBanner from '../../../components/ErrorBanner'
import LoadingBanner from "../../../components/LoadingBanner";
import TablePagination from "../../../components/TablePagination";
import {useQueryClient} from '@tanstack/react-query';
import {useAuth} from "../../../providers/AuthProvider";
import {useProject} from "../../../providers/ClientProjectProvider";
import Team from "../../../models/Team";
import TeamTile from "../../teams/TeamTile";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import CandidateSort from "./CandidateSort";
import TeamToggleLayout from "../../teams/TeamToggleLayout";
import TeamCandidateProvider, {useTeamCandidate} from "../../../providers/TeamCandidateProvider";
import {useAPI} from "../../../config/API";
import TeamCandidateHorizontalTile from "../../teams/TeamCandidateHorizontalTile";
import ScopingCallBanner from "./ScopingCallBanner";

// const DEFAULT_PER_PAGE = 9;
// const DEFAULT_FILTER = listTypes.All;

const TeamActions = (props) => {

    const {team, isDisabled, addToCandidates, removeFromCandidates} = useTeamCandidate();
    const {auth} = useAuth();
    const {project} = useProject();
    const hasBeenAssigned = useMemo(
        () => !!project?.assigned_team_candidate?.id, [
            project?.assigned_team_candidate
        ]);
    const isAssigned = useMemo(
        () => project?.assigned_team_candidate?.id === team?.id, [
            project?.assigned_team_candidate,
            team?.id
        ]);

    const canAssignTalentForProject = auth?.canAssignTalentForProject(project);
    const canRequestInterview = auth?.canRequestTalentInterviewForProject(project);
    const permissionToInvite = auth?.canInviteTalentForProject(project);

    return team.isShortlisted() ? (
        <div className="flex flex-row items-center gap-3">
            <button
                disabled={props.isDisabled || isDisabled}
                onClick={() => {
                    props.onRequest(async () => {
                        let updatedTeam = await removeFromCandidates(project);

                        console.log('TeamActions', {updatedTeam: updatedTeam})
                        if (updatedTeam) {
                            props.onUpdated(updatedTeam)
                        }
                    })
                }}
                className="btn btn-dark btn-block text-base min-w-[250px]">
                {(team.declinedPosition() || team.job_candidate?.has_confirmed_payout) ? "Remove From Shortlist": "Cancel Invite"}
            </button>
            <button
                disabled={true}
                onClick={() => true}
                className="btn btn-dark btn-block text-base min-w-[250px]">
                {!team.declinedPosition() ? (
                    team.job_candidate?.has_confirmed_payout ? "Proposal Ready" : "Waiting for proposal"
                ) : "Not Interested"}
            </button>
        </div>
    ) : (
        <button
            disabled={props.isDisabled || isDisabled}
            onClick={() => {
                return props.onRequest(async () => {
                    let updatedTeam = await addToCandidates(project);

                    if (updatedTeam) {
                        props.onUpdated(updatedTeam)
                    }
                })
            }}
            className="btn btn-primary btn-block text-base min-w-[250px]">
            Invite To Propose
        </button>
    )
}
const TeamMatches = (props) => {

    const {project, isProjectUpdating, postUpdate} = useProject();

    const {
        captureTalentRequest,
        onRequest,
        listTypes,
        isDisabled
    } = useOutletContext();

    const navigate = useNavigate();
    const location = useLocation();

    const [searchParams, setSearchParams] = useSearchParams();

    const orientation = useMemo(() => {
        if (searchParams.has('view')) {
            return Team.LAYOUTS[TB.toUpper(searchParams.get('view'))] || Team.LAYOUTS.CARD
        }
        return Team.LAYOUTS.CARD;
    }, [searchParams.toString()]);

    const [DEFAULT_PER_PAGE, setDEFAULT_PER_PAGE] = useState(() => {
        let maxItems = TB.floor(window.innerWidth / 380);
        maxItems = Math.max(maxItems, 1);
        maxItems = Math.min(maxItems, 4);

        if (!maxItems) return 3;
        return maxItems * 3
    });

    const getPerPage = useMemo(() => {
        if (searchParams.has('per_page')) {
            return parseInt(searchParams.get('per_page')) || DEFAULT_PER_PAGE
        }
        return DEFAULT_PER_PAGE;
    }, [searchParams.get('per_page')]);

    const activeListType = useMemo(() => {
        if (searchParams.has('filter')) {
            return TB.startCase(searchParams.get('filter')) || listTypes.All
        }
        return listTypes.All;
    }, [searchParams.get('filter')]);

    const [sortBy, setSortBy] = useState(() => {
        if (project.matchSort() && Team.matchSortingOptions()[project.matchSort()]) {
            return project.matchSort();
        }
        return Team.matchSortingOptions()[0]
    });
    const [listTypeDropdown, setListTypeDropdown] = useState(false);


    const requestParams = useMemo(() => {
        let params = {
            project: project?.id,
            // accomplished_disciplines: TB.map(position?.disciplines, 'id'),
            per_page: getPerPage,
            sort_by: sortBy,
            page: searchParams.get('page') || 1
        };

        if (searchParams.get('only_interested') === '1') {
            params.interested = 1;
        }
        // if(captureTalentRequest) {
        params.capture_talent_request = 1;
        // }

        // params.self_disliked = 0;
        // params.self_liked = 0;
        params.disliked = 0;
        params.liked = 0;
        // params.favorite = 0;
        // params.self_liked = 0;

        switch (TB.startCase(searchParams.get('filter')) || listTypes.All) {
            case listTypes.Favorite:
                params.favorite = 1;
                break;
            case listTypes.Liked:
                // params.self_liked = 1;
                params.liked = 1;
                break;
            case listTypes.Archive:
                params.disliked = 1;
                break;
        }

        console.log('', params);

        return params
    }, [getPerPage, sortBy, captureTalentRequest, activeListType, searchParams.toString()]);

    const {auth} = useAuth();
    const queryClient = useQueryClient();
    const {
        data: teamMatches,
        isFetching,
        isInitialLoading: isLoading,
        isRefetching,
        error,
        refetch,
    } = useAPI(['teamMatches', requestParams]
    )

    const typeFilterOptions = useMemo(() => {
        return [
            {type: listTypes.All, count: teamMatches?.matches_total || 0},
            {type: listTypes.Liked, count: (teamMatches?.liked_total || 0) || (teamMatches?.self_liked_total || 0)},
            {type: listTypes.Archive, count: (teamMatches?.disliked_total || 0) || (teamMatches?.self_disliked_total || 0)}
        ];
    }, [
        teamMatches?.matches_total,
        teamMatches?.liked_total,
        teamMatches?.disliked_total,
        teamMatches?.self_liked_total,
        teamMatches?.self_disliked_total,
        isLoading
    ]);

    const togglePerPage = async (perPage) => {

        let updateParams = new URLSearchParams(searchParams);

        if (!searchParams.has('per_page') && perPage === DEFAULT_PER_PAGE()) {
            return;
        }
        if (searchParams.has('per_page') && parseInt(searchParams.get('per_page')) !== perPage) {
            updateParams.set('per_page', perPage);
        } else {
            updateParams.delete('per_page')
        }
        updateParams.delete('page')

        await setSearchParams(updateParams, {replace: true})
    }

    const toggleInterestedOnly = async () => {

        let updateParams = new URLSearchParams(searchParams);

        if (searchParams.get('only_interested') !== '1') {
            updateParams.set('only_interested', '1');
        } else {
            updateParams.delete('only_interested')
        }
        updateParams.delete('page')

        await setSearchParams(updateParams, {replace: true})
    }

    const toggleActiveFilter = async (filter) => {

        let updateParams = new URLSearchParams(searchParams);

        if (filter && searchParams.get('filter') !== TB.slugify(filter)) {
            updateParams.set('filter', TB.slugify(filter));
        } else {
            updateParams.delete('filter')
        }
        updateParams.delete('page')

        await setSearchParams(updateParams, {replace: true})
    }

    const refreshTalentFor = async (updatedTalent) => {
        if (!updatedTalent) {
            return;
        }

        let updatedMatches = {...teamMatches};
        let refresh = false;

        updatedMatches.teams = TB.map([...updatedMatches.teams], talent => {
            if (talent.id === updatedTalent.id) {
                let match = Team.make({...talent});
                if (!match.is_archived && updatedTalent.is_archived) {
                    refresh = true;
                }
                if (match.declinedPosition() && !match.is_archived && updatedTalent.is_archived) {
                    updatedMatches.self_disliked_total = (updatedMatches.self_disliked_total || 0) + 1;
                    refresh = true;
                }
                return Team.make({...talent, ...updatedTalent});
            }
            return talent;
        });

        console.log('refreshTalentFor', {refresh});

        if (refresh) {
            return queryClient.invalidateQueries({
                predicate: ({queryKey}) => {
                    let params = queryKey[1] || {};
                    return queryKey[0] === 'teamMatches' && params.project === project.id;
                }
            })
        }

        if (isRefetching || isLoading || isFetching) {
            return;
        }

        return queryClient.setQueryData(['teamMatches', requestParams], updatedMatches);
    }

    const updateTalentFilters = async (pageUpdates, refresh) => {
        queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'teamMatches' && params.project === project?.id;
            }
        }, page => {
            if (!page) return undefined
            return {
                ...page, ...pageUpdates
            }
        })

        if (refresh) {
            console.log('REFRESH updateTalentFilters')
            return queryClient.invalidateQueries({
                predicate: ({queryKey}) => {
                    let params = queryKey[1] || {};
                    return queryKey[0] === 'teamMatches' && params.project === project.id;
                }
            })
        }
    }
    //
    //
    // if (!team?.is_visible) {
    //     return <div/>
    // }

    let currentPage = teamMatches?.current_page,
        lastPage = teamMatches?.last_page,
        totalMatches = teamMatches?.total,
        // talentList = teamMatches?.talent,
        talentList = teamMatches?.teams,
        isLoadingTeam = !talentList;
    //
    // // const canEditProjectAndPositions = auth?.canEditProjectAndPositions(project);
    //
    // let shareableCandidates = 0;
    //
    // if (teamMatches && teamMatches.total > 0) {
    //     // Add client favorites to sharable total
    //     shareableCandidates += teamMatches.favorites_total || 0
    //     // Add project_team liked candidates to sharable total
    //     shareableCandidates += (teamMatches.liked_total || 0) + (teamMatches.self_liked_total || 0)
    //     // Add project_team candidates that have showed interest sharable total
    //     // shareableCandidates += team?.total_interested_candidates || team?.interested_candidates_count || 0
    //     // Add project_team candidates that have been invited to sharable total
    //     // shareableCandidates += team?.total_selected_candidates || 0
    // }
    // const canShare = true;//!team?.hasBeenFilled() && shareableCandidates > 0;
    //
    // // console.log("shareableCandidates", shareableCandidates)
    // // const onShare = e => {
    // //     e.currentTarget.blur();
    // //     let params = new URLSearchParams(searchParams);
    // //     params.set('shareTalentForRole', String(position?.id));
    // //     return setSearchParams(params);
    // // }
    // const onShowProposal = talent => {
    //     let existingParams = new URLSearchParams(searchParams);
    //     existingParams.set('tId', talent.id)
    //     return setSearchParams(existingParams)
    // }
    //
    // const emptyBannerMessage = useMemo(() => {
    //     switch (activeListType) {
    //         case listTypes.Liked:
    //             return `No talent saved yet.`;
    //         case listTypes.Archive:
    //             return `No talent added to archive yet.`;
    //         case listTypes.All:
    //         default:
    //             if (searchParams.get('only_interested') === '1') {
    //                 return `No matching talent has shown interest yet.`;
    //             }
    //             return `No matching talent available.`;
    //     }
    // }, [activeListType]);

    const teamOptions = useMemo(() => {
        return TB.filter(teamMatches?.teams || [], t => TB.isDefined(t))
    }, [teamMatches?.teams, isLoading, isRefetching, isFetching])


    useEffect(() => {
        let invalidate = false;
        switch (activeListType) {
            case listTypes.All:
                if (TB.filter(teamOptions, ['job_candidate.was_disliked', true]).length) {
                    invalidate = true;
                }
                break;
            case listTypes.Liked:
                if (TB.filter(teamOptions, ['job_candidate.was_liked', false]).length) {
                    invalidate = true;
                }
                break;
            case listTypes.Archive:
                if (TB.filter(teamOptions, ['job_candidate.was_disliked', false]).length) {
                    invalidate = true;
                }
                break;
        }
        // console.log('refresh', {invalidate, disliked: TB.filter(talentOptions, ['job_candidate.was_disliked', false]).length})

        if(invalidate && !isFetching) {
            queryClient.invalidateQueries({
                predicate: ({queryKey}) => {
                    let params = queryKey[1] || {};
                    return queryKey[0] === 'teamMatches';
                },
                fetchStatus: 'idle'
            })
        }
    }, [
        teamMatches?.liked_total,
        teamMatches?.disliked_total,
        teamMatches?.self_liked_total,
        teamMatches?.self_disliked_total,
        activeListType
    ]);

    return (
        <div className="w-full">
            {!error && !isLoadingTeam && (
                <ScopingCallBanner/>
            )}
            <div className="flex-grow flex flex-col items-stretch pt-6 position-matches-row">
                <div className="container mx-auto items-stretch px-5 lg:px-8 flex flex-col gap-5 mt-4">
                    <div className="md:flex items-center flex-row mb-5">
                        <div className="position-matches-title pb-2 md:pb-0">
                            <h5 className="mb-0 font-semibold">Talent Pool: Team Matches</h5>
                        </div>

                        {project.approved_teams_count > 0 && (
                            <div className="project-bidding-types-filter-container items-center justify-end">

                                <div className="mx-3.5">
                                    <CandidateSort options={Team.matchSortingOptions()} sortBy={sortBy}
                                                   onChange={(sort) => {
                                                       project.setMatchSort(sort);
                                                       let params = new URLSearchParams(searchParams);
                                                       params.delete('page')
                                                       setSearchParams(params);
                                                       return setSortBy(sort)
                                                   }}/>
                                </div>
                                <div className="individual-role-list-filter hidden md:flex">

                                    {typeFilterOptions.map((option, i) => {
                                        let isActive = activeListType === option.type;

                                        return (
                                            <button
                                                key={`tlt-${i}`}
                                                className={TB.mapClass("whitespace-no-wrap btn btn-tab", {
                                                    "active no-click": isActive
                                                })}
                                                disabled={isDisabled || !option.count || isLoading}
                                                onClick={() => toggleActiveFilter(option.type)}>
                                                {option.type} <small>({option.count})</small>
                                            </button>
                                        );
                                    })}
                                </div>


                                {/* TODO: replace reactstrap dropdown with react-select | disable options that have 0 */}

                                <Dropdown className='filter-dropdown block md:hidden py-2'
                                          style={styles.listTypeDropdown}
                                          isOpen={listTypeDropdown}
                                          toggle={() => setListTypeDropdown(!listTypeDropdown)}>

                                    <DropdownToggle caret tag="a"
                                                    style={{cursor: 'pointer'}}>
                                        {activeListType}
                                        <small>({TB.find(typeFilterOptions, ['type', activeListType])?.count})</small>
                                    </DropdownToggle>

                                    <DropdownMenu>
                                        {typeFilterOptions.map((option, i) => (
                                            <DropdownItem
                                                key={`sort${i}`} style={{fontSize: '12px'}}
                                                onClick={() => toggleActiveFilter(option.type)}>
                                                {option.type} <small>({option.count})</small>
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>

                            </div>
                        )}

                    </div>

                    {!error && (isLoadingTeam || isLoading || isFetching || isRefetching) && (
                        <LoadingBanner message="Finding Matches" style={{marginBottom: 150}}/>
                    )}

                    {error && (
                        <ErrorBanner
                            title="Something went wrong"
                            message="Unable to load talent. Please try again later"
                            onRetry={refetch}/>
                    )}


                    {!error && !isLoadingTeam && !isLoading && !isFetching && !isRefetching &&(
                        <React.Fragment>
                            {teamOptions?.length > 0 ? (
                                <div className="flex flex-col gap-3">
                                    <div className="flex flex-row gap-2 items-center">
                                        <TeamToggleLayout orientation={orientation} setOrientation={view => {
                                            let params = new URLSearchParams(searchParams);
                                            params.set('view', TB.toLower(view));
                                            return setSearchParams(params)
                                        }}/>
                                        <div className="flex-grow">
                                            <TablePagination
                                                contentClassName="flex-grow"
                                                isDisabled={isProjectUpdating || isDisabled || isFetching || isRefetching || isLoading}
                                                currentPage={currentPage}
                                                useParams={true}
                                                pagesCount={lastPage}
                                                total={totalMatches}
                                                perPage={getPerPage}
                                            >
                                            </TablePagination>
                                        </div>
                                    </div>
                                    <div className="team-list wy-auto relative mt-0">
                                        {orientation === Team.LAYOUTS.CARD && (
                                            <div className="m-auto w-full">
                                                {teamOptions.map(team => (
                                                    <TeamCandidateProvider
                                                        team={team}
                                                        key={`tal-${team.id}`}
                                                    >
                                                        <TeamCandidateHorizontalTile
                                                            onRequest={onRequest}
                                                            onUpdated={refreshTalentFor}
                                                            isDisabled={isProjectUpdating || isDisabled || isLoading || isFetching || isRefetching}
                                                            placeholder={isLoading || isFetching || isRefetching}>

                                                            <div className="w-full flex flex-col items-stretch">
                                                                <TeamActions
                                                                    onRequest={onRequest}
                                                                    onUpdated={refreshTalentFor}
                                                                    isDisabled={isProjectUpdating || isDisabled || isLoading || isFetching || isRefetching}
                                                                />
                                                            </div>

                                                        </TeamCandidateHorizontalTile>
                                                    </TeamCandidateProvider>
                                                ))}
                                            </div>
                                        )}

                                        {orientation === Team.LAYOUTS.COLUMN && (
                                            <CardList
                                                className="flex-grow max-w-full py-4"
                                                minHeight={715} itemsPerRow={3}
                                                items={teamOptions.map((team, i) => (
                                                    <TeamCandidateProvider
                                                        team={team}
                                                        key={`team-${team.id}`}>
                                                        <TeamTile
                                                            onRequest={onRequest}
                                                            onUpdated={refreshTalentFor}
                                                            isDisabled={isProjectUpdating || isDisabled || isLoading || isFetching || isRefetching}
                                                            placeholder={isLoading || isFetching || isRefetching}>
                                                            <div className="potential-candidate-actions [&>*]:!flex-col">
                                                                <TeamActions
                                                                    onRequest={onRequest}
                                                                    onUpdated={refreshTalentFor}
                                                                    isDisabled={isProjectUpdating || isDisabled || isLoading || isFetching || isRefetching}
                                                                />
                                                            </div>
                                                        </TeamTile>
                                                    </TeamCandidateProvider>
                                                ))}/>
                                        )}
                                    </div>
                                    {lastPage > 1 && (
                                        <div className="mb-3">
                                            <TablePagination
                                                isDisabled={isProjectUpdating || isDisabled || isFetching || isRefetching || isLoading}
                                                currentPage={currentPage}
                                                useParams={true}
                                                pagesCount={lastPage}
                                                total={totalMatches}
                                                perPage={getPerPage}
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div
                                    className="bg-white self-stretch mx-auto w-full max-w-[650px] px-5 py-6 flex flex-col items-center gap-4">
                                    <img src={'/images/curating_teams.png'} className="max-w-full mx-auto h-64"/>

                                    <p>
                                        We are curating teams for your project!
                                    </p>
                                    {!project.hasCompletedProjectScopeCall() && (
                                        <button
                                            onClick={async () => {
                                                let confirm = await project.confirmScopingCallRequest();

                                                if (confirm) {
                                                    await onRequest(async () => {
                                                        return postUpdate({scope_call_requested_at: new Date()})
                                                    })

                                                    return TB.toast("Request Submitted! We will be reaching out shortly.")
                                                }
                                            }}
                                            disabled={project.hasRequestedProjectScopeCall() || isDisabled || isProjectUpdating}
                                            className={TB.mapClass('btn', {
                                                'btn-outline-dark': !project.hasRequestedProjectScopeCall(),
                                                'btn-outline-dark btn-outline-white': project.hasRequestedProjectScopeCall()
                                            })}
                                        >
                                            {!project.hasRequestedProjectScopeCall() ? "Schedule Scoping Call" : "Scoping Call Pending"}
                                        </button>
                                    )}
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div>
    );
}

export default TeamMatches

const styles = {
    listTypeDropdown: {
        alignSelf: 'stretch',
        textAlign: 'center',
        border: '1px solid rgb(25, 42, 62)',
        boxSizing: 'border-box',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '19px',
        letterSpacing: '0.01em',
        maxWidth: 'none',
    },
};